module.exports = __webpack_public_path__ + "img/10-1.e7bb6587.png";